export default __webpack_public_path__ + "static/media/choose6.544c888c.png";